export function afterGet(record) {
  const newRecord = {
    ...record,
    configData: {
      enabled: record.enabled,
      sendForSku: record.sendForSku,
      sendForDescription: record.sendForDescription,
    },
  };

  delete newRecord.enabled;
  delete newRecord.sendForDescription;
  delete newRecord.sendForSku;

  return newRecord;
}
